import * as React from 'react';

import { PopupPosition } from 'shared/entities/components/Popup';
import { TranslationNode } from 'shared/entities/localization';
import { TypographyWeight } from 'shared/newEntities/components/Typography';
import { useElementOverflow } from 'shared/entities/common/hooks';

import Reference from '../Reference';

import './MultiLineCroppedContent.modules.scss';

type Props = {
  popupContent?: TranslationNode;
  children: React.ReactElement;
  className?: string;
  titleWeight?: TypographyWeight;
  position?: PopupPosition[];
  disabled?: boolean;
  maxLines?: 1 | 2 | 3;
};

const MultiLineCroppedContent: React.FC<Props> = ({
  popupContent,
  children,
  className,
  titleWeight,
  position,
  disabled,
  maxLines = 1
}: Props) => {
  const contentRef = React.useRef<HTMLDivElement>(null);
  const { hasOverflow: showPopup } = useElementOverflow({
    ref: contentRef,
    deps: [maxLines, children]
  });

  if (!children) {
    return null;
  }

  return (
    <div styleName="multi-line-cropped-content-container" className={className}>
      <Reference
        title={popupContent || children}
        trigger={
          <div styleName="multi-line-cropped-content">
            <div
              ref={contentRef}
              styleName={`multi-line-cropped-content_lines-${maxLines}`}
            >
              {children}
            </div>
          </div>
        }
        disabled={disabled || !showPopup}
        position={
          position || [
            PopupPosition.topCenter,
            PopupPosition.bottomCenter,
            PopupPosition.rightBottom
          ]
        }
        titleWeight={titleWeight}
      />
    </div>
  );
};

export default React.memo(MultiLineCroppedContent);
